import React from 'react';
import { IntakeFormContextProvider } from '../Context/IntakeFormContext';
import LeadIntakePreview from './LeadIntakePreview';

const LeadInTakeWrapper = () => {
  return (
    <IntakeFormContextProvider>
      <LeadIntakePreview />
    </IntakeFormContextProvider>
  );
};
export default LeadInTakeWrapper;
